import { useAuth0 } from "@auth0/auth0-react";
import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Box, Typography } from "@mui/material";
import * as sanitizeHtml from "sanitize-html";
import * as util from "./util";
import * as api from "../api/api";
import { useTheme } from "../ThemeContext/ThemeContext";

// import preval from 'preval.macro';
// const buildTimestamp = preval`module.exports = new Date().toISOString();`;
// console.log(buildTimestamp)

export default function PrivacyAndTermsDialog({
  name,
  buttonTitle,
  title,
  page,
  replacementButton,
  open,
  setopen,
}) {
  const [html, setHtml] = React.useState("");
  const { colors } = useTheme();


  React.useEffect(() => {
    const fn = async () => {
      const resp = await fetch(page);
      const dirty = await resp.text();
      const clean = sanitizeHtml(dirty, {
        allowedTags: sanitizeHtml.defaults.allowedTags.concat([
          "head",
          "body",
          "table",
          "tr",
          "thead",
          "td",
          "img",
          "br",
          "hr",
          "area",
          "base",
          "basefont",
          "input",
          "link",
          "meta",
          "style",
        ]),
        allowedAttributes: {
          a: ["name", "target", "href"],
          img: ["src", "srcset", "alt", "title", "width", "height", "loading"],
        },
        allowedClasses: {
          "*": ["*"],
        },
        transformTags: {
          html: "div",
          head: "div",
          body: "div",
        },
        allowVulnerableTags: true,
        exclusiveFilter: function (frame) {
          if (frame.tag === "div") {
            // filter out foot notes for now
            // if (frame.attribs['class'] === 'c10' || frame.attribs['class'] === 'c19') {
            //     return true
            // }
          }
          return false;
        },
      });

      setHtml(clean);
    };
    fn();
  }, [page]);

  // Inject theme-aware CSS into the loaded HTML content
  React.useEffect(() => {
    if (html && colors) {
      const style = document.createElement('style');
      style.textContent = `
        .content {
          background-color: ${colors?.background?.primary} !important;
          color: ${colors?.text?.primary} !important;
          margin: 0 !important;
          padding: 2rem !important;
          width: 100% !important;
          min-height: 70vh !important;
          box-sizing: border-box !important;
        }
        .content p, .content span, .content div, .content td, .content th {
          color: ${colors?.text?.primary} !important;
        }
        .content a {
          color: ${colors?.primary?.main} !important;
        }
        .content table {
          background-color: ${colors?.background?.primary} !important;
        }
        .content .MsoNormal, .content .TableText, .content .TableHead {
          color: ${colors?.text?.primary} !important;
        }
        .content .WordSection1 {
          background-color: ${colors?.background?.primary} !important;
          color: ${colors?.text?.primary} !important;
          margin: 0 !important;
          padding: 0 !important;
        }
      `;
      document.head.appendChild(style);
      
      return () => {
        document.head.removeChild(style);
      };
    }
  }, [html, colors]);

  const { getAccessTokenSilently } = useAuth0();

  React.useEffect(() => {
    const fn = async () => {
      const token = await getAccessTokenSilently();
      await api.GetPrivacy(token, (data) => {
        // console.log({ data: data })
        if (util.isPrivacyAgreed(data, name)) {
          // setOpen(false)
        } else {
          setopen(true);
        }
      });
    };
    fn();
  }, [getAccessTokenSilently, name, setopen]);

  const handleAgree = () => {
    const fn = async () => {
      const token = await getAccessTokenSilently();
      await api.PostPrivacy(token, {
        name: name,
      });
      setopen(false);
    };
    fn();
  };

  return (
    <div>
      <Dialog 
        maxWidth="lg" 
        fullWidth 
        open={open}
        PaperProps={{
          sx: {
            backgroundColor: colors?.background?.paper || "white",
            margin: 0,
            padding: 0,
            "& .MuiDialog-paper": {
              margin: 0,
              padding: 0,
            }
          }
        }}
      >
        <AppBar sx={{ position: "sticky", backgroundColor: colors?.primary?.main }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1, color: "white" }} variant="h6" component="div">
              {title}
            </Typography>
            <Button 
              autoFocus 
              color="inherit" 
              onClick={handleAgree}
              sx={{ color: "white" }}
            >
              I Agree
            </Button>
          </Toolbar>
        </AppBar>
        <Box 
          sx={{ 
            m: 0,
            p: 0,
            backgroundColor: colors?.background?.paper || "white",
            color: colors?.text?.primary || "black",
            minHeight: "70vh",
            width: "100%"
          }}
        >
          <div
            className="content"
            dangerouslySetInnerHTML={{ __html: html }}
            style={{
              backgroundColor: colors?.background?.paper || "white",
              color: colors?.text?.primary || "black",
              padding: "2rem",
              margin: 0,
              width: "100%",
              minHeight: "70vh",
              boxSizing: "border-box"
            }}
          ></div>
        </Box>
      </Dialog>
    </div>
  );
}
